var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#FF6201"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6652 20.2085C19.4559 20.2085 17.6652 21.9993 17.6652 24.2085V37.5418C17.6652 40.2085 18.9986 41.5418 21.6652 41.5418H40.3319C42.9986 41.5418 44.3319 40.2085 44.3319 37.5418V26.8752C44.3319 26.1388 43.7346 25.5418 42.9986 25.5418H41.6652V21.5418C41.6652 20.8054 41.0679 20.2085 40.3319 20.2085H21.6652ZM21.6652 22.8752H38.9986V25.5418H21.6652C20.9292 25.5418 20.3319 24.9449 20.3319 24.2085C20.3319 23.4721 20.9292 22.8752 21.6652 22.8752ZM37.6652 30.8752C38.4012 30.8752 38.9986 31.4721 38.9986 32.2085C38.9986 32.9449 38.4012 33.5418 37.6652 33.5418C36.9292 33.5418 36.3319 32.9449 36.3319 32.2085C36.3319 31.4721 36.9292 30.8752 37.6652 30.8752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2);
export default __webpack_public_path__ + "static/media/ic-2.c3e1dbebba62bd8f0ac7656ec3af7e2a.svg";
export { ForwardRef as ReactComponent };